import { c as _c } from "react/compiler-runtime";
import { postEntitiesByFpIdBusinessOwnersKycLinksMutation } from '@onefootprint/fetch-dashboard';
import { useClipboard, useToggle } from '@onefootprint/hooks';
import type { PrivateBusinessOwnerKycLink } from '@onefootprint/request-types/dashboard';
import { Dialog, InlineAlert, LinkButton, Form as UIForm, useToast } from '@onefootprint/ui';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { FormProvider, useForm, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import PermissionGate from '@/components/permission-gate';
type FormValues = {
  boIds: string[];
  hasOptionSelected?: boolean;
};
type AwaitingBosEventProps = {
  fpId: string;
};
const AwaitingBosEvent = t0 => {
  const $ = _c(58);
  const {
    fpId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "auditTrail.timeline.awaitingBosEvent"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const {
    toast
  } = useToast();
  const [isOpen, open, close] = useToggle();
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [bos, setBos] = useState(t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = postEntitiesByFpIdBusinessOwnersKycLinksMutation();
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const mutation = useMutation(t3);
  let t4;
  if ($[3] !== fpId || $[4] !== mutation || $[5] !== open) {
    t4 = async () => {
      const data = await mutation.mutateAsync({
        path: {
          fpId
        },
        body: {}
      });
      setBos(data);
      open();
    };
    $[3] = fpId;
    $[4] = mutation;
    $[5] = open;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleGenerateLinks = t4;
  let t5;
  if ($[7] !== close || $[8] !== fpId || $[9] !== mutation || $[10] !== t || $[11] !== toast) {
    t5 = async t6 => {
      const {
        boIds: sendToBoIds
      } = t6;
      await mutation.mutateAsync({
        path: {
          fpId
        },
        body: {
          sendToBoIds
        }
      });
      toast({
        title: t(_temp),
        description: t(_temp2)
      });
      close();
    };
    $[7] = close;
    $[8] = fpId;
    $[9] = mutation;
    $[10] = t;
    $[11] = toast;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const handleSubmit = t5;
  let t6;
  if ($[13] !== t) {
    t6 = t(_temp3);
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t6) {
    t7 = <div className="text-label-2 text-info">{t6}</div>;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="text-label-2 text-tertiary">·</div>;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t) {
    t9 = t(_temp4);
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const t10 = mutation.isPending;
  let t11;
  if ($[20] !== t) {
    t11 = t(_temp5);
    $[20] = t;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== handleGenerateLinks || $[23] !== mutation.isPending || $[24] !== t11) {
    t12 = <LinkButton variant="label-2" onClick={handleGenerateLinks} disabled={t10}>{t11}</LinkButton>;
    $[22] = handleGenerateLinks;
    $[23] = mutation.isPending;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12 || $[27] !== t9) {
    t13 = <div className="relative top-[-3px]"><PermissionGate scopeKind="manual_review" fallbackText={t9}>{t12}</PermissionGate></div>;
    $[26] = t12;
    $[27] = t9;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t13 || $[30] !== t7) {
    t14 = <div className="flex flex-wrap gap-x-1 md:flex-nowrap md:gap-1">{t7}{t8}{t13}</div>;
    $[29] = t13;
    $[30] = t7;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t) {
    t15 = t(_temp6);
    $[32] = t;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t) {
    t16 = t(_temp7);
    $[34] = t;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== mutation.isPending || $[37] !== t16) {
    t17 = {
      label: t16,
      type: "submit",
      form: "resend-form",
      loading: mutation.isPending
    };
    $[36] = mutation.isPending;
    $[37] = t16;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t) {
    t18 = t(_temp8);
    $[39] = t;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== close || $[42] !== mutation.isPending || $[43] !== t18) {
    t19 = {
      label: t18,
      disabled: mutation.isPending,
      onClick: close
    };
    $[41] = close;
    $[42] = mutation.isPending;
    $[43] = t18;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== bos || $[46] !== handleSubmit) {
    t20 = bos && <Form onSubmit={handleSubmit} businessOwners={bos} />;
    $[45] = bos;
    $[46] = handleSubmit;
    $[47] = t20;
  } else {
    t20 = $[47];
  }
  let t21;
  if ($[48] !== close || $[49] !== isOpen || $[50] !== t15 || $[51] !== t17 || $[52] !== t19 || $[53] !== t20) {
    t21 = <Dialog title={t15} open={isOpen} size="compact" onClose={close} primaryButton={t17} secondaryButton={t19}>{t20}</Dialog>;
    $[48] = close;
    $[49] = isOpen;
    $[50] = t15;
    $[51] = t17;
    $[52] = t19;
    $[53] = t20;
    $[54] = t21;
  } else {
    t21 = $[54];
  }
  let t22;
  if ($[55] !== t14 || $[56] !== t21) {
    t22 = <>{t14}{t21}</>;
    $[55] = t14;
    $[56] = t21;
    $[57] = t22;
  } else {
    t22 = $[57];
  }
  return t22;
};
const Form = t0 => {
  const $ = _c(39);
  const {
    onSubmit,
    businessOwners
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "auditTrail.timeline.awaitingBosEvent"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const {
    copy,
    copiedText
  } = useClipboard();
  let t2;
  if ($[1] !== businessOwners) {
    t2 = businessOwners.map(_temp9);
    $[1] = businessOwners;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = {
      defaultValues: {
        boIds: t2
      }
    };
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const methods = useForm(t3);
  const {
    control,
    register,
    handleSubmit
  } = methods;
  let t4;
  if ($[5] !== control) {
    t4 = {
      control,
      name: "boIds"
    };
    $[5] = control;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const boIds = useWatch(t4);
  const noOptionSelected = boIds.length === 0;
  let t5;
  if ($[7] !== handleSubmit || $[8] !== onSubmit) {
    t5 = handleSubmit(onSubmit);
    $[7] = handleSubmit;
    $[8] = onSubmit;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t(_temp10);
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <p className="text-body-2">{t6}</p>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== businessOwners || $[15] !== copiedText || $[16] !== copy || $[17] !== t) {
    let t9;
    if ($[19] !== copiedText || $[20] !== copy || $[21] !== t) {
      t9 = bo_0 => <div key={bo_0.id} className="flex justify-between"><UIForm.Checkbox name="boIds" label={bo_0.name} value={bo_0.id} /><LinkButton variant="label-2" onClick={() => copy(bo_0.link)}>{copiedText === bo_0.link ? t(_temp11) : t(_temp12)}</LinkButton></div>;
      $[19] = copiedText;
      $[20] = copy;
      $[21] = t;
      $[22] = t9;
    } else {
      t9 = $[22];
    }
    t8 = businessOwners.map(t9);
    $[14] = businessOwners;
    $[15] = copiedText;
    $[16] = copy;
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[23] !== t8) {
    t9 = <div className="flex flex-col gap-3">{t8}</div>;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t7 || $[26] !== t9) {
    t10 = <div className="flex flex-col gap-4">{t7}{t9}</div>;
    $[25] = t7;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== noOptionSelected || $[29] !== register || $[30] !== t) {
    t11 = noOptionSelected ? <><InlineAlert className="mt-4" variant="warning">{t(_temp13)}</InlineAlert><input type="hidden" {...register("hasOptionSelected", {
        required: true
      })} /></> : null;
    $[28] = noOptionSelected;
    $[29] = register;
    $[30] = t;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] !== t10 || $[33] !== t11 || $[34] !== t5) {
    t12 = <form id="resend-form" onSubmit={t5}>{t10}{t11}</form>;
    $[32] = t10;
    $[33] = t11;
    $[34] = t5;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  let t13;
  if ($[36] !== methods || $[37] !== t12) {
    t13 = <FormProvider {...methods}>{t12}</FormProvider>;
    $[36] = methods;
    $[37] = t12;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  return t13;
};
export default AwaitingBosEvent;
function _temp($) {
  return $.feedback.title;
}
function _temp2($_0) {
  return $_0.feedback.description;
}
function _temp3($_1) {
  return $_1.waitingMessage;
}
function _temp4($_2) {
  return $_2.resendLinkMissingPermission;
}
function _temp5($_3) {
  return $_3.resendLink;
}
function _temp6($_4) {
  return $_4.dialog.title;
}
function _temp7($_5) {
  return $_5.dialog.buttons.send;
}
function _temp8($_6) {
  return $_6.dialog.buttons.cancel;
}
function _temp9(bo) {
  return bo.id;
}
function _temp10($) {
  return $.dialog.description;
}
function _temp11($_0) {
  return $_0.dialog.copied;
}
function _temp12($_1) {
  return $_1.dialog.copyLink;
}
function _temp13($_2) {
  return $_2.error;
}